export const alertMSG = {
    offlineTitle: `You Are Offline`,
    offlineHTML: `No internet connectivity!`,
}
